<div [style.height.px]="height" class="loading-container">
  <mat-progress-spinner class="main-spinner" mode="indeterminate" diameter="25">
  </mat-progress-spinner>
</div>